import { render, staticRenderFns } from "./SurfacesForm.vue?vue&type=template&id=4d69095e&"
import script from "./SurfacesForm.vue?vue&type=script&lang=js&"
export * from "./SurfacesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports